import { render, staticRenderFns } from "./OsAppBar.vue?vue&type=template&id=6b5cd7a1&scoped=true"
import script from "./OsAppBar.vue?vue&type=script&lang=ts"
export * from "./OsAppBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5cd7a1",
  null
  
)

export default component.exports